// extracted by mini-css-extract-plugin
export var card = "_5b-0";
export var content = "_5b-1";
export var contentLoading = "_5b-2";